import { api, ApiError } from "./client";

function downloadName(disposition, fallback) {
  const encoded = disposition?.match(/filename\*\s*=\s*UTF-8''([^;]+)/i);
  const plain = disposition?.match(/filename\s*=\s*(?:"([^"]+)"|([^;]+))/i);
  let name = plain?.[1] || plain?.[2]?.trim() || fallback;
  if (encoded) {
    try {
      name = decodeURIComponent(encoded[1]);
    } catch {
      // A malformed optional filename must not discard a valid download.
    }
  }
  return name.split("/").pop().split("\\").pop() || fallback;
}

export async function downloadFile(url, { filename = "download", signal } = {}) {
  let response;
  try {
    response = await api.request({
      url, method: "GET", responseType: "blob", safeRead: true, signal,
    });
  } catch (error) {
    if (error.data instanceof Blob && error.data.type.includes("json")) {
      let data;
      try {
        data = JSON.parse(await error.data.text());
      } catch {
        throw error;
      }
      throw new ApiError({ response: { ...error.response, data }, code: error.code });
    }
    throw error;
  }
  if (signal?.aborted) return;
  const objectUrl = URL.createObjectURL(response.data);
  const link = document.createElement("a");
  link.href = objectUrl;
  link.download = downloadName(response.headers?.["content-disposition"], filename);
  try {
    document.body.appendChild(link);
    link.click();
  } finally {
    link.remove();
    setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
  }
}
